<div class="not-found-container">
  <div class="text-center">
    <h1 class="not-found-status">404</h1>
    <h2 class="not-found-message">Not Found</h2>
  </div>
</div>
